import type { MenuItem, TagId, TagConfig } from 'src/types/types';
import { CardItem } from 'src/components/CardItem/CardItem';

import styles from './styles.module.scss';

type CardListProps = {
  items: MenuItem[];
  tagConfig: Record<TagId, TagConfig>;
  priorityCount?: number;
};

export const CardList = ({
  items,
  tagConfig,
  priorityCount = 0,
}: CardListProps) => (
  <ul className={styles.list}>
    {items
      .filter((item) => item.available)
      .map((item, index) => (
        <CardItem
          key={item.id}
          item={item}
          tagConfig={tagConfig}
          priority={index < priorityCount}
        />
      ))}
  </ul>
);
